import React from 'react';
import Input from '../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../../Core/Fields/Floating/SelectSearch';
import CheckboxNew from '../../../../../Core/Fields/Floating/CheckboxNew';

const InventorySettings = ({ formData, onFieldChange, extraData }) => {
  return (
    <div className="col-md-12">
      <div
        style={{
          backgroundColor: '#EBE6FA',
          height: '100%',
          borderRadius: '4px',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: '10px',
          border: '1px solid #ccc', // added subtle border
        }}
      >
        {/* Row 1 */}
        <div style={{ display: 'flex', gap: '15px' }}>
          <div style={{ flex: 1 }}>
            <Input
              label="Shelf Life (Days)"
              style={{ height: '30px' }}
              value={formData.shelf_life_in_days}
              onChange={(e) =>
                onFieldChange('shelf_life_in_days', e.target.value)
              }
            />
          </div>

          <div style={{ flex: 1 }}>
            <Date
              label="End of Life"
              style={{ height: '30px' }}
              value={formData.end_of_life}
              onChange={(e) => onFieldChange('end_of_life', e.target.value)}
            />
          </div>

          <div style={{ flex: 1 }}>
            <SelectSearch
              label="Default Material Request Type"
              style={{ height: '30px' }}
              value={formData.default_material_request_type}
              onChange={(e) =>
                onFieldChange('default_material_request_type', e.target.value)
              }
              list={extraData.request_types}
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              createNewUrl="/master/material-request-type/create"
              createNewLabel="Create New Request Type"
            />
          </div>

          <div style={{ flex: 1 }}>
            <SelectSearch
              label="Valuation Method"
              style={{ height: '30px' }}
              value={formData.valuation_method}
              onChange={(e) =>
                onFieldChange('valuation_method', e.target.value)
              }
              list={extraData.valuation_methods}
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
            />
          </div>
        </div>

        {/* Row 2 */}
        <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
          <div style={{ flex: 1 }}>
            <Input
              label="Warranty Period (Days)"
              style={{ height: '30px' }}
              value={formData.warranty_Period_in_days}
              onChange={(e) =>
                onFieldChange('warranty_Period_in_days', e.target.value)
              }
            />
          </div>

          <div style={{ flex: 1 }}>
            <Input
              label="Weight per Unit"
              style={{ height: '30px' }}
              value={formData.weight_per_unit}
              onChange={(e) =>
                onFieldChange('weight_per_unit', e.target.value)
              }
            />
          </div>

          <div style={{ flex: 1 }}>
            <Input
              label="Weight UOM"
              style={{ height: '30px' }}
              value={formData.weigh_oum}
              onChange={(e) => onFieldChange('weigh_oum', e.target.value)}
            />
          </div>

          <div style={{ flex: 1, display: 'flex', alignItems: 'center', marginTop : '15px' }}>
            <CheckboxNew
              id="allowNegativeStock"
              label="Allow Negative Stock"
              labelPosition="right"
              checked={formData.allow_negative_stock}
              onChange={(e) =>
                onFieldChange('allow_negative_stock', e.target.checked)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventorySettings;
